// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"171570d3","71":"576c3de8","84":"085ca52f","126":"93dfc8cb","484":"0eff00f3","642":"b03ca8cd","740":"afaf88b2","856":"946197c8","862":"08b7fa47","895":"8a9cda07","907":"6cf532c4","965":"d7c0e101","978":"58489cd7"}[chunkId] + ".chunk.js";
};